import { RequestListagemProps } from 'hooks/useRequestListagem';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export type DreCustosConfiguracao = {
    idDreMercadologicaCusto: number;
    vlTotal: number;
    index: number;

    dreMercadologicaConfigCusto: {
        idDreMercadologicaConfigCusto: number;
        fgAtivo: boolean;
        fgObrigatorio: boolean;
        fgPercentual: boolean;
        fgTotalizador: boolean;
        dsNomeExibicao: string;
        dsNomeVariavel: string;
        dsValorConfig: string;
        nrSequencia: number;
        dsObservacao: string;
        dreMercadologicaGrupoExibicao: DreSubgrupo;

        dreTipoPreenchimento: {
            idDreTipoPreenchimento: number;
        };
    };
};

export type DreVendasConfiguracao = {
    idDreMercadologicaVenda: number;
    vlTotal: number;
    vlAjuste: number;
    vlTotalAjustado: number;
    dsJustificativaAjuste: string;
    index: number;

    dreMercadologicaConfigVenda: {
        idDreMercadologicaConfigVenda: number;
        fgAtivo: boolean;
        dsNomeExibicao: string;
        dsNomeVariavel: string;
        nrSequencia: number;
        dsObservacao: string;
        dreMercadologicaGrupoExibicao: DreSubgrupo;
    };
};

export type DreDespesasConfiguracao = {
    idDreMercadologicaDespesa: number;
    vlTotal: number;
    fgRecorrente: boolean;
    index: number;

    dreMercadologicaConfigDespesa: {
        idDreMercadologicaConfigDespesa: number;
        fgAtivo: boolean;
        dsNomeExibicao: string;
        dsNomeVariavel: string;
        fgObrigatorio: boolean;
        fgRecorrente: boolean;
        dsObservacao: string;
        dreMercadologicaGrupoExibicao: DreSubgrupo;

        dreTipoPreenchimento: {
            idDreTipoPreenchimento: number;
        };
    };
};

export type DreImpostosConfiguracao = {
    idDreMercadologicaImposto: number;
    vlTotal: number;
    index: number;

    dreMercadologicaConfigImposto: {
        idDreMercadologicaConfigImposto: number;
        idTipoRegimeTributario: number;
        nrSequencia: number;
        dsNomeExibicao: string;
        dsNomeVariavel: string;
        fgAtivo: boolean;
        dsObservacao: string;
    };
};

type DreDespesasVariaveis = {
    idDreMercadologicaDespesaVariavel: number;
    dsDespesa: string;
    fgRecorrente: boolean;
    vlTotal: number;
};

type Loja = {
    idLoja: number;

    lojaConfiguracoes: {
        idLojaConfiguracao: number;
        idConfiguracaoPropriedade: number;
        dsValor: string;
        configuracaoPropriedade: {
            dsChave: string;
            dsConfiguracao: string;
            idConfiguracaoPropriedade: number;
        };
    }[];
};

export type DreStatus = {
    idDreStatus: number;
    dreStatusEnum: 'FINALIZADO' | 'A_PREENCHER' | 'EM_PREENCHIMENTO' | 'BLOQUEADO';
};

type DreFormSubgrupo<T> = {
    dreMercadologicaGrupoExibicao: DreSubgrupo;
    dreMercadologicaValor: T[];
};

export type DreForm = {
    idDreMercadologica: number;
    dtFim: string;
    dtInicio: string;
    loja: Loja | null;
    dreStatus: DreStatus | null;
    dreMercadologicaCustos: DreFormSubgrupo<DreCustosConfiguracao>[];
    dreMercadologicaVendas: DreFormSubgrupo<DreVendasConfiguracao>[];
    dreMercadologicaDespesas: DreFormSubgrupo<DreDespesasConfiguracao>[];
    dreMercadologicaImpostos: DreImpostosConfiguracao[];
    dreMercadologicaDespesasVariaveis: DreDespesasVariaveis[];
};

export type RequestDreForm = {
    status: number;
    data: {
        data: DreForm;
    };
};

interface DreMenuGrupoTipoProps {
    idDreMercadologicaTipoGrupoExibicao: number;
    dsDreMercadologicaTipoGrupoExibicao: string;
}

interface DreMenuGrupoProps {
    idDreMercadologicaGrupoExibicao: number;
    fgAtivo: boolean;
    dsDreMercadologicaGrupoExibicao: string;
    nrSequencia: number;
    tipoDreMercadologicaGrupoExibicao: DreMenuGrupoTipoProps;
}

export interface DreMenuProps {
    idDreMercadologicaTipoGrupoExibicao: number;
    dsDreMercadologicaTipoGrupoExibicao: string;
    nrSequencia: number;
    gruposExibicao: DreMenuGrupoProps[];
}

interface DreMercadologicaConfigApuracaoProps {
    idDreMercadologicaConfigApuracao: number;
    dsNomeExibicao: string;
    dsNomeVariavel: string;
    dsObservacao: string;
    dsFormula: string;
    nrSequencia: number;
    fgTotalizar: boolean;
    fgAtivo: boolean;
}

interface DreMercadologicaApuracoesProps {
    vlTotal: number;
    dreMercadologicaConfigApuracao: DreMercadologicaConfigApuracaoProps;
}

export interface DreListProps {
    idDreMercadologica: number;
    loja: Loja;
    dreStatus: DreStatus;
    dreMercadologicaApuracoes: DreMercadologicaApuracoesProps[];
    dsMesExtenso: string;
    dtInicio: string;
    isLoading?: boolean;
}

export interface RequestDreListProps extends RequestListagemProps {
    data: DreListProps[];
}

export const Apuracao = {
    RECEITA_BRUTA: 'apuracao_receita_bruta',
    RECEITA_LIQUIDA: 'apuracao_receita_liquida',
    LUCRO_LIQUIDO: 'apuracao_lucro_liquido',
    CMV: 'apuracao_cmv',
    GASTOS: 'apuracao_gastos',
} as const;
